import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成
import { updateBaseMenu, getMenuList, addBaseMenu, deleteBaseMenu, getBaseMenuById } from '@/api/menu';
import infoList from '@/mixins/infoList';
import icon from '@/view/superAdmin/menu/icon';
export default {
  name: 'Menus',
  components: {
    icon: icon
  },
  mixins: [infoList],
  data: function data() {
    return {
      checkFlag: false,
      listApi: getMenuList,
      dialogFormVisible: false,
      dialogTitle: '新增菜单',
      menuOption: [{
        ID: '0',
        title: '根菜单'
      }],
      form: {
        ID: 0,
        path: '',
        name: '',
        hidden: '',
        parentId: '',
        component: '',
        meta: {
          title: '',
          icon: '',
          defaultMenu: false,
          closeTab: false,
          keepAlive: false
        },
        parameters: []
      },
      rules: {
        path: [{
          required: true,
          message: '请输入菜单name',
          trigger: 'blur'
        }],
        component: [{
          required: true,
          message: '请输入文件路径',
          trigger: 'blur'
        }],
        'meta.title': [{
          required: true,
          message: '请输入菜单展示名称',
          trigger: 'blur'
        }]
      },
      isEdit: false,
      test: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.pageSize = 999;
              _context.next = 3;
              return _this.getTableData();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    addParameter: function addParameter(form) {
      if (!form.parameters) {
        this.$set(form, 'parameters', []);
      }

      form.parameters.push({
        type: 'query',
        key: '',
        value: ''
      });
    },
    deleteParameter: function deleteParameter(parameters, index) {
      parameters.splice(index, 1);
    },
    changeName: function changeName() {
      this.form.path = this.form.name;
    },
    setOptions: function setOptions() {
      this.menuOption = [{
        ID: '0',
        title: '根目录'
      }];
      this.setMenuOptions(this.tableData, this.menuOption, false);
    },
    setMenuOptions: function setMenuOptions(menuData, optionsData, disabled) {
      var _this2 = this;

      menuData && menuData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            title: item.meta.title,
            ID: String(item.ID),
            disabled: disabled || item.ID === _this2.form.ID,
            children: []
          };

          _this2.setMenuOptions(item.children, option.children, disabled || item.ID === _this2.form.ID);

          optionsData.push(option);
        } else {
          var _option = {
            title: item.meta.title,
            ID: String(item.ID),
            disabled: disabled || item.ID === _this2.form.ID
          };
          optionsData.push(_option);
        }
      });
    },
    handleClose: function handleClose(done) {
      this.initForm();
      done();
    },
    // 懒加载子菜单
    load: function load(tree, treeNode, resolve) {
      resolve([{
        id: 31,
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        id: 32,
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }]);
    },
    // 删除菜单
    deleteMenu: function deleteMenu(ID) {
      var _this3 = this;

      this.$confirm('此操作将永久删除所有角色下该菜单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return deleteBaseMenu({
                  ID: ID
                });

              case 2:
                res = _context2.sent;

                if (res.code === 0) {
                  _this3.$message({
                    type: 'success',
                    message: '删除成功!'
                  });

                  if (_this3.tableData.length === 1 && _this3.page > 1) {
                    _this3.page--;
                  }

                  _this3.getTableData();
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 初始化弹窗内表格方法
    initForm: function initForm() {
      this.checkFlag = false;
      this.$refs.menuForm.resetFields();
      this.form = {
        ID: 0,
        path: '',
        name: '',
        hidden: '',
        parentId: '',
        component: '',
        meta: {
          title: '',
          icon: '',
          defaultMenu: false,
          keepAlive: ''
        }
      };
    },
    // 关闭弹窗
    closeDialog: function closeDialog() {
      this.initForm();
      this.dialogFormVisible = false;
    },
    // 添加menu
    enterDialog: function enterDialog() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.$refs.menuForm.validate( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!valid) {
                              _context3.next = 13;
                              break;
                            }

                            if (!_this4.isEdit) {
                              _context3.next = 7;
                              break;
                            }

                            _context3.next = 4;
                            return updateBaseMenu(_this4.form);

                          case 4:
                            res = _context3.sent;
                            _context3.next = 10;
                            break;

                          case 7:
                            _context3.next = 9;
                            return addBaseMenu(_this4.form);

                          case 9:
                            res = _context3.sent;

                          case 10:
                            if (res.code === 0) {
                              _this4.$message({
                                type: 'success',
                                message: _this4.isEdit ? '编辑成功' : '添加成功!'
                              });

                              _this4.getTableData();
                            }

                            _this4.initForm();

                            _this4.dialogFormVisible = false;

                          case 13:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 添加菜单方法，id为 0则为添加根菜单
    addMenu: function addMenu(id) {
      this.dialogTitle = '新增菜单';
      this.form.parentId = String(id);
      this.isEdit = false;
      this.setOptions();
      this.dialogFormVisible = true;
    },
    // 修改菜单方法
    editMenu: function editMenu(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.dialogTitle = '编辑菜单';
                _context5.next = 3;
                return getBaseMenuById({
                  id: id
                });

              case 3:
                res = _context5.sent;
                _this5.form = res.data.menu;
                _this5.isEdit = true;

                _this5.setOptions();

                _this5.dialogFormVisible = true;

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  }
};